import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AlarmOnIcon(props: IconProps) {
    return <Icon {...props} iconKey={"alarm_on"}/>
}
